var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-0 px-2 tiss-subtitle",staticStyle:{"font-size":"7pt","background-color":"gainsboro !important","-webkit-print-color-adjust":"exact"}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }